<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('remark.remark')" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog h100p df-c-ct">

          <div class="left df-l-fs border-r" v-if="remarks_b.length">

            <div class="_themecolor f-xs f-bold lh30">{{$t('remark.presetRemark')}}</div>
            <div class="days df-w-fs scrolly">
              <div v-for="(x,i) in remarks_b" :key="i" class="day df mr20" @click="selectRemark(x)">
                <img
                  style="width:20px;height:20px;margin-right:16px;" mode="aspectFill"
                  :src="x.select?iconCheckok:iconChecknull" />
                <div class="day-label f-dark f-xs">{{x.remark}}</div>
              </div>
            </div>

          </div>
          
          <div class="right f1 df">
            <div class="inputBox plr10 mlr20 border df-l-fs f1 scrolly" @click="focusTextarea">
              <div class="tags df-w-c-fs ptb5" @click.stop.prevent="()=>{}">
                <div
                  v-for="(x,i) in remarks_select" :key="i"
                  class="tag border2 pl10 pr20 ptb5 mtb5 mlr10 f-black"
                  @click.stop.prevent="selectRemark(x)">
                  <div>{{x.remark}}</div>
                  <div class="close-btn">
                    <i class="el-icon el-icon-close f-xxs"></i>
                  </div>
                </div>
              </div>
              <textarea
                ref="textarea"
                class="textarea mytextarea w100p f1 ptb0"
                :placeholder="$t('remark.inputRemark')"
                v-model="remarkContent" />
            </div>
          </div>

        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogRemark',
  data() {
    return {
      isShowDialog: false,
      obj: '',
      type: '',
      remarks_all: [],
      remarks_b: [],
      remarks_select: [],
      remarkContent: '',
    }
  },
  methods: {
    async open(val) {
      const { type, obj } = val
      const { remarksTemplateList: list, remarks: content } = obj
      this.obj = obj
      this.type = type

      await this.getRemarks()

      const ARR = []
      if (list) {
        list.forEach(x1 => {
          const ITEM = this.remarks_all.find(x2 => x1.id === x2.id && x1.remark === x2.remark)
          if (ITEM) {
            ITEM.select = true
            ARR.push(ITEM)
          }
        })
      }
      this.remarks_select = ARR

      this.remarkContent = content || ''

      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.remarkContent = ''
    },
    selectRemark(item) {
      item.select = !item.select
      if (item.select) {
        this.remarks_select.push(item)
      } else {
        const INDEX = this.remarks_select.findIndex(x1 => x1.id === item.id)
        if (INDEX > -1) {
          this.remarks_select.splice(INDEX, 1)
        }
      }
    },
    focusTextarea() {
      this.$refs.textarea.focus()
    },
    async submit() {
      this.$emit('submitDialog', {
        type: this.type,
        list: this.remarks_select.map(x1 => ({
          id: x1.id,
          remark: x1.remark
        })),
        content: this.remarkContent,
        obj: this.obj
      })
    },
    async getRemarks() {
      const _R = await this.getData('remarkTemp', {
        shopId: this.currentShopId,
        type: {'item':1,'order':2}[this.type],
        // serverPosOpen: true,
        // customerPosOpen: true,
      })
      // console.log(`%c预设备注:`, 'color: #f00;', _R)
      this.remarks_all = _R
      this.remarks_b = _R.filter(x1 => x1.serverPosOpen)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 30px 20px 0;box-sizing: border-box;
  .left{
    width: 366px;height: 300px;word-break: normal;
    .days{
      max-height: 270px;
      .day{
        padding: 10px 0;box-sizing: border-box;
        .day-label{line-height: 20px;}
      }
    }
  }
  .right{
    height: 300px;
    .inputBox{
      .tags{
        .tag{
          position: relative;
          .close-btn{
            width: 14px;height: 14px;
            position: absolute;top: 5px;right: 4px;
          }
        }
      }
      .textarea{border: none;height: 200px;}
    }
  }
  .border{border: 1px solid #979797;}
  .border2{border: 2px solid #000;}
  .border-r{border-right: 1px solid #979797;}
}
</style>